export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


// WEBPACK FOOTER //
// ./node_modules/swiper/core/translate/maxTranslate.js